import React from 'react';
import Notifications from '@mui/icons-material/Notifications';
import PriorityHigh from '@mui/icons-material/PriorityHigh';
import { ChangeRequestIcon, Tooltip } from 'framework/ui/mui-builder';
import { useFieldHelper } from 'framework/ui/field';
import { ViewStatus } from '../../types';

const commonSx = {
  fontSize: 12,
  mr: 0.5,
  color: 'primary.main',
};

const ViewStatusNotification: React.FC = () => {
  const { getValue: getViewStatus } = useFieldHelper({ source: 'viewStatus' });
  const { getValue: getHasChangeRequests } = useFieldHelper({ source: 'areVacancyChangesRequested', value: false });
  const viewStatus = getViewStatus();
  const hasChangeRequests = getHasChangeRequests();

  const renderStatusIcon = () => {
    if (viewStatus === ViewStatus.NEW) {
      return (
        <Tooltip title="This vacancy is new and you didn't see it yet.">
          <PriorityHigh sx={commonSx} />
        </Tooltip>
      );
    } else if (viewStatus === ViewStatus.UPDATED) {
      return (
        <Tooltip title="This vacancy was updated and you didn't see the changes yet.">
          <Notifications sx={commonSx} />
        </Tooltip>
      );
    }
    return null;
  };

  const renderChangeRequestIcon = () => {
    if (hasChangeRequests) {
      return (
        <Tooltip title="This vacancy has change requests.">
          <ChangeRequestIcon sx={{ fill: 'currentcolor', ...commonSx }} />
        </Tooltip>
      );
    }
    return null;
  };

  return (
    <>
      {renderStatusIcon()}
      {renderChangeRequestIcon()}
    </>
  );
};

export default ViewStatusNotification;
